import Style from '../assets/style.scss';
import {
	BCForm,
	BCFormItem,
	ValidateStatus,
	findMessage,
	BCInputMultiLanguage,
	IColProps,
	BCNotification
} from '@bimser/components';
import { toLowerCase, MLHelper, ValidationHelper } from '@bimser/core';
import OnChangeFilePropertyPayload from '../entities/OnChangeFilePropertyPayload';
import { IProfileFormFolder } from '../entities/IProfileFormFolder';
import React from 'react';
interface FolderOptionsProps {
	folderProps: IProfileFormFolder;
	onFolderPropChange: (payload: OnChangeFilePropertyPayload) => void;
}

const FolderOptions = (props: FolderOptionsProps) => {
	React.useEffect(() => {
		if (props.folderProps.hasValidation) {
			BCNotification.error({
				description: findMessage.get('101984'),
				message: findMessage.get('100926')
			});
		}
	}, [props.folderProps.hasValidation]);

	const onNameChanged = (culture: string, value: string) => {
		const name = {
			...props.folderProps.folderName,
			[culture]: value.trim()
		};
		props.onFolderPropChange({
			propertyName: 'folderName',
			value: name
		});
	};

	const onDescChanged = (culture: string, value: string) => {
		const description = {
			...props.folderProps.folderDescription,
			[culture]: value.trim()
		};
		props.onFolderPropChange({
			propertyName: 'folderDescription',
			value: description
		});
	};

	const itemLabelCol: IColProps = { style: { width: '112px' } };
	const itemWrapperCol: IColProps = { span: 15 };

	return (
		<div className={Style.folderOptions}>
			<BCForm>
				<BCFormItem
					validateStatus={ValidateStatus.validating}
					label={findMessage.get('100770')}
					required
					labelCol={itemLabelCol}
					wrapperCol={itemWrapperCol}
					labelAlign="left"
				>
					<BCInputMultiLanguage
						supportedLanguages={MLHelper.supportedLanguages}
						currentLanguage={MLHelper.currentLanguage}
						onLanguageValueChange={onNameChanged}
						values={props.folderProps.folderName}
						size="small"
						maxLength={255}
					/>
				</BCFormItem>

				<BCFormItem
					validateStatus={ValidateStatus.validating}
					label={findMessage.get('100772')}
					required={false}
					labelCol={itemLabelCol}
					wrapperCol={itemWrapperCol}
					labelAlign="left"
				>
					<BCInputMultiLanguage
						supportedLanguages={MLHelper.supportedLanguages}
						currentLanguage={MLHelper.currentLanguage}
						onLanguageValueChange={onDescChanged}
						values={props.folderProps.folderDescription}
						size="small"
						maxLength={1024}
					/>
				</BCFormItem>
			</BCForm>
		</div>
	);
};

export default FolderOptions;
